
import Error from "../utils/Error";
import { formatDisplayDate } from "../utils/fomatDate";
import { useEvents } from "../../hooks/useEvent";

const AllEvents = () => {
 
const { data:events, isLoading,isError, error } = useEvents();


  if (isError)
    return <Error message={error ? error.message : "Error Loading NewsLetter"} />;

  return (
    <div className="2xl:container w-full flex flex-col px-6 md:px-[70px]">
      <div
        className={`grid items-stretch  grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 md:gap-10`}
      >
        {events?.data?.slice().sort((a, b) => new Date(b.date) - new Date(a.date)).map((item, i) => (
          <div key={i}>
            {/* <Link to={`/blog/${item.id}`}> */}
            {/* <div className="grid grid-cols-[3fr_1fr] md:grid-cols-[2.3fr_1fr] ">
                            <div className="text-left">
                                <div className="flex flex-col gap-3 md:gap-4 mb-8 w-[80%] md:w-10/12">
                                    <p className="text-14 md:text-20 font-medium text-[#046353]">
                                            {item.title}
                                        </p>
                                  
                                    <p className="text-16 text-[#41444B] hidden md:block">
                                        {item.description}
                                    </p>
                                    <div className="flex text-14 md:text-16 text-headingtext font-medium gap-10">
                                        <p>{item.location}</p>
                                    </div>
                                </div>
                                <div className="flex text-14 md:text-16 text-[#41444B] gap-5 font-medium gap-10">
                                    <p><span className="text-headingtext font-[600]">Date :</span> {formatDisplayDate(item.date)}</p>
                                    <p> <span className="text-headingtext font-[600]">Time :</span> {item.time}</p>
                                </div>

                            </div>

                            <img
                                src={`${item.img}`}
                                alt="dd"
                                className="rounded-[12px] min-w-[140px] min-h-[100px] max-h-[350px]"
                                style={{
                                    boxShadow: "0px 0px 20px rgba(114, 116, 121, 0.25)",
                                }}
                            />
                        </div> */}

            <div
              className="flex flex-col h-full rounded-[24px]"
              style={{
                boxShadow: "0px 0px 20px rgba(114, 116, 121, 0.25)",
              }}
            >
              <img
                src={`${item.img}`}
                alt="dd"
                className=" min-w-[140px] min-h-[300px] max-h-[300px] rounded-[24px] "
                style={{
                  boxShadow: "0px 0px 20px rgba(114, 116, 121, 0.25)",
                }}
              />
              {/* <ImageWithSkeleton
                  src={item.img}
                
                  alt="image"
                  containerClass="object-cover min-w-[140px] h-[250px] rounded-[24px]  "
                /> */}
              
              <div className="text-left  p-5 ">
                <div className="flex flex-col gap-3 md:gap-4 mb-6 ">
                  <p className="text-14 md:text-20 font-medium text-[#046353]">
                    {item.title}
                  </p>

                  <p className="text-16 text-[#41444B] ">{item.description}</p>
                </div>
                <div className="flex flex-col text-14 md:text-16  gap-5 font-medium gap-10">
                  <p className="flex gap-2">
                    <span className="text-[#41444B] font-[600]">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="icon icon-tabler icons-tabler-outline icon-tabler-calendar-week"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z" />
                        <path d="M16 3v4" />
                        <path d="M8 3v4" />
                        <path d="M4 11h16" />
                        <path d="M7 14h.013" />
                        <path d="M10.01 14h.005" />
                        <path d="M13.01 14h.005" />
                        <path d="M16.015 14h.005" />
                        <path d="M13.015 17h.005" />
                        <path d="M7.01 17h.005" />
                        <path d="M10.01 17h.005" />
                      </svg>
                    </span>{" "}
                    {formatDisplayDate(item.date)}
                  </p>
                  <p className="flex gap-2 text-[#41444B] font-[600]">
                    {" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="icon icon-tabler icons-tabler-outline icon-tabler-clock-hour-4"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                      <path d="M12 12l3 2" />
                      <path d="M12 7v5" />
                    </svg>{" "}
                    {item.time}
                  </p>
                </div>
                <div className="flex text-14 md:text-16  text-headingtext font-medium gap-10 mt-5">
                  <p className="flex gap-3">
                    {" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={30}
                      height={30}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="icon icon-tabler icons-tabler-outline icon-tabler-map-pin"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
                      <path d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z" />
                    </svg>
                    {item.location}
                  </p>
                </div>
              </div>
            </div>


            
          </div>
        ))}
      </div>
    </div>
  );
};

export default AllEvents;
